<template>
  <!-- Modal backdrop for kiosk mode -->
  <div v-if="getKiosk && webCart && false" class="modal-backdrop" @click="webCart = false"></div>

  <div class="parent" v-show="webCart" :class="{ 'modal-cart': getKiosk }">
    <font-awesome-icon v-if="getKiosk" icon="fa-xmark" class="exit" @click="webCart = false" />
    <div v-if="getKiosk" class="modal-header">
      <h2>Your Order</h2>
    </div>
    <h2 class="title" v-if="!getKiosk">
      <div>
        <span :class="showCart ? 'active' : 'dull'" @click="showCart = true">Order</span>
        <span v-if="satOrKiosk && getSatellite" id="divider"> | </span>
        <span v-if="satOrKiosk && getSatellite" class="table" @click="$router.push('/floorplan')">{{ formatedTable }}</span>
        <span v-if="!satOrKiosk" id="divider"> | </span>
        <span :class="!showCart ? 'active' : 'dull'" @click="showCart = false" v-if="!satOrKiosk"> History</span>
      </div>
    </h2>
    <Cart v-if="showCart" @showCheckoutModal="openCheckout = !openCheckout" @loadOrderLineItem="sendItem" @showSatelliteModal="openSatellite = !openSatellite" />
    <HistoryColumn v-if="!showCart" @showTab="showTab" />
  </div>
  <CheckoutModal ref="checkoutChild" :open="openCheckout" />
  <SatelliteModal :open="openSatellite" @close="openSatellite = !openSatellite" :products="products" @set-tab="setTab" @pay-tab="handleTab" />
  <KioskCheckout :open="openKioskCheckout" @close="closeKioskCheckout" />
  <div class="cart-icon" v-if="portrait || getKiosk" @click="toggleCart">
    <div class="cart-count" v-if="cartCount > 0">{{ cartCount }}</div>
    <font-awesome-icon class="icon" icon="shopping-cart" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import HistoryColumn from "../History/HistoryColumn.vue";
import Cart from "./Cart.vue";
import CheckoutModal from "./CheckoutModal.vue";
import SatelliteModal from "./SatelliteModal.vue";
import KioskCheckout from "./KioskCheckout.vue";

export default {
  name: "CartColumn",
  components: {
    HistoryColumn,
    Cart,
    CheckoutModal,
    SatelliteModal,
    KioskCheckout,
  },

  beforeMount() {},

  mounted() {
    if (this.open) {
      this.openCheckout = this.checkoutOpen;
    }
    // Hide cart initially for kiosk mode
    if (this.getKiosk) {
      this.webCart = false;
    }
  },

  computed: {
    ...mapGetters({
      cartCount: "cartCount",
      socketConnected: "socketConnected",
      products: "cartProducts",
      getKiosk: "getKiosk",
      getKioskOrderDetails: "getKioskOrderDetails",
      getSatellite: "getSatellite",
      currentTable: "currentTable",
      currentLayout: "currentLayout",
    }),

    satOrKiosk() {
      if (this.getSatellite || this.getKiosk) {
        return true;
      }
      return false;
    },

    formatedLayout() {
      return this.currentLayout.layout.split("_")[1];
    },

    formatedTable() {
      if (Object.keys(this.currentTable).length) {
        return this.currentTable.table.split("_").join(" ");
      } else {
        return "No Table Selected";
      }
    },
  },
  emits: ["loadOrderLineItem"],
  props: ["open", "checkoutOpen"],
  data() {
    return {
      showCart: true,
      openCheckout: false,
      webCart: true,
      portrait: false,
      openWebOrder: false,
      openSatellite: false,
      openKioskCheckout: false,
    };
  },
  methods: {
    closeKioskCheckout(flag) {
      this.openKioskCheckout = false;
      if (flag) {
        this.$router.push("/startOrder");
      }
    },

    handleTab() {
      this.openCheckout = true;
      this.openSatellite = false;
    },

    setTab() {
      this.$refs.checkoutChild.delivery = "dine-in";
      this.$refs.checkoutChild.name = "table" in this.currentTable ? this.formatedLayout + "_" + this.currentTable.table : null;
      this.$refs.checkoutChild.payLater();
      this.openSatellite = !this.openSatellite;
      this.$router.push("/floorplan");
      if (this.$refs.checkoutChild.errors.length == 0) {
        this.$notify({
          text: "Tab set",
          type: "success",
          duration: 1500,
        });
      } else if (this.$refs.checkoutChild.errors) {
        this.$refs.checkoutChild.errors.map((error) => {
          if (error == "Name is required") {
            this.$notify({
              text: "No table. Please Select a table.",
              type: "error",
              duration: 1500,
            });
          }
        });
        this.$router.push("/floorplan");
      }
      this.$store.dispatch("setCurrentTable", {});
    },

    sendItem(item) {
      this.$emit("loadOrderLineItem", item);
    },

    showTab(column) {
      column === "cart" ? (this.showCart = true) : false;
    },

    handleCheckout() {
      if (this.getKiosk) {
        this.openKioskCheckout = true;
      } else {
        this.openCheckout = !this.openCheckout;
      }
    },

    toggleCart() {
      if (this.getKiosk) {
        this.openKioskCheckout = true;
      } else {
        this.topScroll();
      }
    },

    topScroll() {
      let media = matchMedia("(orientation: portrait)");
      if (media.matches) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (window.screenTop < window.innerHeight) {
          this.webCart = !this.webCart;
        } else {
          this.webCart = true;
        }
      } else {
        this.webCart = !this.webCart;
      }
    },

    redirect() {
      if ("redirect_status" in this.$route.query) {
        if (this.$route.query.redirect_status == "succeeded") {
          this.$refs.checkoutChild.completeTransaction(false, true);
          this.$notify({
            text: "Payment Succeeded.",
            type: "success",
            duration: 1500,
          });
        } else {
          this.$notify({
            text: "Payment Failed.",
            type: "error",
            duration: 1500,
          });
        }
      }
    },
  },
  watch: {
    // open() {
    //   this.openCheckout = this.open;
    // },
    /***products() {
      if (this.products.length > 0 && this.socketConnected) {
        this.redirect();
      }
    },***/
  },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

.modal-backdrop {
  @extend .modal;
  
}

.parent {
  display: flex;
  flex-direction: column;
  padding: 0rem 1rem 0rem 1rem;
  max-height: 100vh;
  overflow-y: scroll;
  background-color: var(--secondary-colour);
  box-shadow: var(--box-shadow);
  width: 20rem;
  border-radius: 1rem 0rem 0rem 0rem;

  &.modal-cart {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    max-width: 500px;
    max-height: 80vh;
    border-radius: 1rem;
    z-index: 99999999;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    
  }
}

.exit {
  top: 1rem;
  right: 1.5rem;
  font-size: 2rem;
  background: none;
  border: none;
  box-shadow: none;
  margin: 1rem;
  color: var(--action-colour);
  cursor: pointer;
}

.modal-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;

  h2 {
    margin: 0;
    color: var(--text-colour);
  }
}
.title {
  .active {
    color: var(--action-colour);
  }
  .dull {
    color: var(--text-colour);
  }
  #divider {
    color: var(--text-colour);
  }
  .table {
    color: var(--text-colour);
    text-transform: capitalize;
    cursor: pointer;
  }
}

.cart-icon {
  // display: none;

  &.cart-icon {
    position: fixed;
    top: auto;
    bottom: 1rem;
    right: 1rem;
    color: var(--action-colour);
    cursor: pointer;
    background-color: var(--secondary-colour);
    border: 0.25rem solid var(--primary-colour);
    border-radius: 50%;
    width: 6rem;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;

    .icon {
      font-size: 2rem;
    }
    .cart-count {
      position: absolute;
      top: -15px;
      right: -15px;
      background-color: var(--warning-colour);
      color: var(--secondary-text-colour);
      border-radius: 50%;
      width: 3rem;
      height: 3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
    }
  }
}

@media only screen and (orientation: portrait) {
  .parent {
    width: inherit;
    padding-bottom: 1rem;
    flex: 1;
    border-radius: 0rem 0rem 1rem 1rem;
    max-height: inherit;
  }
  .cart-icon {
    position: fixed;
    top: auto;
    bottom: 1rem;
    right: 1rem;
    color: var(--action-colour);
    cursor: pointer;
    background-color: var(--secondary-colour);
    border: 0.25rem solid var(--primary-colour);
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;

    .cart-count {
      position: absolute;
      top: -10px;
      right: -10px;
      background-color: var(--warning-colour);
      color: var(--secondary-text-colour);
      border-radius: 50%;
      width: 2rem;
      height: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
    }
  }
}
</style>
